import styled, { keyframes } from 'styled-components';
import { MdClose } from 'react-icons/md';

export const MainTitle = styled.h2`
  font-size: 20px !important;
  color: var(--brandColor) !important;
  padding-bottom: 24px;
`;

// SnackBar styles starts
const NoticeAnimation = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

export const SnackBar = styled.div`
  z-index: 999;
  position: sticky;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.color ? props.color : 'var(--normalTxtColor)')};
  background: ${(props) => (props.background ? props.background : 'var(--siteSecondaryBgColor)')};
  text-align: center;
  overflow: hidden;
  -webkit-box-shadow: 0 0 2px var(--greyColor);
  -moz-box-shadow: 0 0 2px var(--greyColor);
  box-shadow: 0 0 2px var(--greyColor);
  animation: ${NoticeAnimation} 1s linear alternate;
  padding: 5px 27px 5px 10px;
  font-size: 14px;
  @media (min-width: 576px) {
    height: 35px;
    font-size: 15px;
  }
  @media (min-width: 768px) {
    position: ${(props) => props.fromCoursePage && 'absolute'};
  }
  @media (min-width: 992px) {
    height: 70px;
    font-size: 16px;
  }
`;

export const CloseButton = styled(MdClose)`
  font-size: 1rem;
  color: ${(props) => (props.color ? props.color : 'var(--normalTxtColor)')};
  position: absolute;
  top: 50%;
  right: 5px;
  transform: translateY(-50%);
  cursor: pointer;
  :hover {
    color: #999;
  }
`;

// account details styles starts
export const ProfileOuter = styled.div`
  padding: 10px;
  display: grid;
  grid-template-columns: 100%;
  @media (min-width: 768px) {
    padding: 16px 10px;
    grid-template-columns: max-content auto;
    align-items: center;
  }
  @media (min-width: 992px) {
    padding: 16px 24px;
  }
`;

export const ProfileAvatar = styled.img`
  height: 180px;
  width: 180px;
  border-radius: 50%;
  transition: 0.5s ease;
  backface-visibility: hidden;
  opacity: 1;
`;

export const ProfileInner = styled.div`
  padding-left: 5px;
  padding-top: 16px;
  @media (min-width: 360px) {
    padding-left: 10px;
  }
  @media (min-width: 768px) {
    padding-top: initial;
    padding-left: 5%;
  }
  @media (min-width: 992px) {
    padding-left: 10%;
  }
`;

export const ProfileTitle = styled.p`
  font-family: var(--headingFont);
  font-size: 15px;
  font-weight: 500;
  color: ${(props) => props.theme.txtPrimary};
  @media (min-width: 992px) {
    font-size: 16px;
  }
`;

export const ProfileContent = styled.p`
  font-family: var(--headingFont);
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${(props) => props.theme.txtPrimary};
  @media (min-width: 992px) {
    font-size: 16px;
  }
`;

export const SubTitle = styled.h4`
  display: inline-block !important;
  margin-bottom: 1rem !important;
  font-size: 20px !important;
  position: relative;
  :after {
    position: absolute;
    content: '';
    display: block;
    width: 100%;
    bottom: 4px;
    height: 3px;
    background: var(--brandColor);
  }
`;
